export default "./src/client/components/auth/login/open-web/spid-button/img/spid-idp-spiditalia.svg?069a2f30934d58d402f27562b6c1767a";